import { appConstants } from "../_constants";
import { appHelpers, authHeader } from "../_helpers";
import { store } from "../_store";

const AirportLocation = {};

export const commonService = {
  getLatestToken,
  getFlightPassengers,
  getAllAirlines,
  getAllAirports,
  getAirlinesFlightNumbers,
  getFlights,
  downloadFlights,
  downloadFlightPassengers,
  postSignIn,
  getUsersByOrganization,
  getAllThreshold,
  getAirlinesThreshold,
  approvePendingThreshold,
  editPendingThreshold,
  setThreshold,
  getCurrentPsc,
  getAllPsc,
  getAllUnprocessedPendingPsc,
  savePsc,
  editPsc,
  approvePsc,
  getNotificationType,
  searchNotificationEmail,
  editNotification,
  getNotificationEmail,
  addEmailNotification,
  getDashboardData,
  getAirlinePayment,
  getSettlements,
  downloadSettlements,
  downloadSettlementsRegional,
  fetchDashboardSummaryCard,
  fetchTokenUtilizationByAirline,
  searchTokenActivity,
  fetchTokenUtilizationByAirport,
  getMyReconciliation,
  getOtherReconciliation,
  processReconciliation,
  updateReconciliation,
  addReconciliation,
  searchTokenUtilized,
  searchBillableVsTotalPassengers,
  downloadBillableVsTotalPassengers,
  downloadTokenUtilization,
  fetchLatestTokensPurchase,
  getAllAirlinePayment,
  searchAirlinePayment,
  downloadAirlinePayment,
  getAuditModules,
  searchAudits,
  getAuditActions,
  searchTimeline,
  getWalletMovementData,
  getAirportLocation,
  saveDataEntry,
  getDataEntry,
  processDataEntry,
  searchTransitPassenger,
  downloadTransitPassenger,
  airlineRouteApproval,
  saveAirlineRoute,
  searchPendingAirlineRoute,
  searchAirlineRoute,
  searchAirlineWalletReport,
  downloadAirlineWalletReport,
  savePdm,
  searchPdm,
  getBillablePassengers,
  saveBillablePassengers,
  searchAppEntityTypes,
  createMakerChecker,
  searchMakerChecker,
  approveMakerChecker,
  rejectMakerChecker,
  getStatementOfAccount,
  downloadStatementOfAccount,
  downloadPdm,
  getOutstandingBillablePassengerReport,
  downloadOutstandingBillablePassengerReport,
//Regional
  savePdmRegional,
  searchPdmRegional,
  downloadPdmRegional,
  searchAirlinePaymentRegional,
  downloadAirlinePaymentRegional,
  getAirlinesFlightNumbersRegional,
  getFlightsRegional,
  downloadFlightsRegional,
  getFlightPassengersRegional,
  downloadFlightPassengersRegional,
  getAuditModulesRegional,
  getAuditActionsRegional,
  searchAuditsRegional,
  downloadBillableVsTotalPassengersRegional,
  searchBillableVsTotalPassengersRegional,
  getNotificationTypeRegional,
  editNotificationRegional,
  searchNotificationEmailRegional,
  addEmailNotificationRegional,
  getBillablePassengersRegional,
  getSettlementsRegional,
  getOutstandingBillablePassengerReportRegional,
  downloadOutstandingBillablePassengerReportRegional,
  getAirlinesThresholdRegional,
  getAllThresholdRegional,
  getCurrentPscRegional,
  setThresholdRegional,
  editPendingThresholdRegional,
  approvePendingThresholdRegional,
  getAllPscRegional,
  searchExchangeRateRegional,
  searchExchangeRatePendingRegional,
  saveExchangeRatePendingRegional,
  approveExchangeRatePendingRegional,
  rejectExchangeRatePendingRegional,
  searchPulledInvoiceRegional,
  approvePulledInvoice,
  initiatePulledInvoice,
  rejectPulledInvoice,
  fetchDashboardSummaryCardRegional,
  fetchTokenUtilizationByAirlineRegional,
  searchTokenActivityRegional,
  fetchTokenUtilizationByAirportRegional,
  fetchLatestTokensPurchaseRegional,
  searchPendingAirlineRouteRegional,
  airlineRouteApprovalRegional,
  saveAirlineRouteRegional,
  getAllAirlinesRegional,
  getAllAirportsRegional,
  processReconciliationRegional,
  getOtherReconciliationRegional,
  getMyReconciliationRegional,
  updateReconciliationRegional,
  addReconciliationRegional,
  processDataEntryRegional,
  getDataEntryRegional,
  saveDataEntryRegional,
  downloadTokenUtilizationRegional,
  searchTokenUtilizedRegional,
  downloadTransitPassengerRegional,
  searchTransitPassengerRegional,
  getStatementOfAccountRegional,
  downloadStatementOfAccountRegional,
  searchAirlineWalletReportRegional,
  downloadAirlineWalletReportRegional,
  getAllUnprocessedPendingPscRegional,
  savePscRegional,
  editPscRegional,
  approvePscRegional,
  searchAirlineRouteRegional,
  searchTimelineRegional,
  getAllCurrencies,
  getAllServiceTypes,
  downloadDataEntryRegional,
  searchFaq,
};

function getOutstandingBillablePassengerReport(payload) {
  return appHelpers.postRequest(`${appConstants.PAS_URL}/api/Report/SearchOutstandingBillablePassengerReport`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadOutstandingBillablePassengerReport(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/report/DownloadOutstandingBillablePassengerReport`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getUsersByOrganization(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/User/Search`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function postSignIn(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/Account/Login`, payload)
    .then(res => {
      const { error } = res.response;
      if (!error) {
        return res;
      } else {
        return appHelpers.formatPromiseResponse(
          error,
          appConstants.ERROR_RESPONSE
        );
      }
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllAirlines() {
  // return appHelpers.getRequest(`${appConstants.PAS_URL}/api/airline/search?IsLocal=${true}`, authHeader())
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Airline/GetAllPscAirline`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllAirports() {
  // return appHelpers.getRequest(`${appConstants.PAS_URL}/api/airport/search?countryCode=NG`)
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Airport/GetAllPscAirport`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAirportLocation() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(AirportLocation);
    }, 2000);
  });
}
function getAirlinesFlightNumbers(airlineId) {
  let payload = {
    From: 0,
    PageSize: 2000,
    Parameter: { AirlineId: airlineId }
  };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/search`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getFlights(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/SearchPSCManifests?from=${payload.From}&size=${payload.Size}`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadFlights(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPSCManifests`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function downloadFlightPassengers(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPSCPassengers`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getAirlinePayment(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Payment/GetPSCPayments?airlineId=${payload.AirlineId}&from={payload.from}&size={payload.PageSize}`
    )
    .then(res => {
      // console.log('res', res);
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
  // return new Promise((resolve, reject)=>{
  //     setTimeout(()=>{
  //         resolve(testData);
  //     }, 4000)
  //
  // });
}

function getAllAirlinePayment(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Payment/GetAllPSCPayments?from={payload.from}&size={payload.PageSize}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchAirlinePayment(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Payment/SearchPSCPayments`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadAirlinePayment(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Payment/DownloadPSCPayments`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getFlightPassengers(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Manifest/GetPSCPassengers?manifestId=${payload.manifestId}&from=${payload.From}&size=${payload.Size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getDashboardData(payload) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const data_ = {
        summary: {
          billablePax: 240000,
          totalBillableAmount: 12500000000000,
          tokensPurchased: 40000,
          unUtilizedToken: 300000,
          totalFlights: 600000
        }
      };
      resolve(appHelpers.promiseResponse(data_));
    }, 2000);
  });
  /*return appHelpers.postRequest(`${appConstants.PAS_URL}/api/Flight/search?showdetails=true`, payload, authHeader())
        .then(res => {
            return res;
        }).catch(
            error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                return appHelpers.formatPromiseResponse(errorMessage, appConstants.ERROR_RESPONSE);
            }
        );*/
}

function getLatestToken() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let airlines = [
        "Aero Air",
        "Medview",
        "Air Peace",
        "Arik",
        "Azman",
        "Dana",
        "Overland"
      ];
      let amounts = [250000, 100000, 200000, 5000, 30000, 800000, 40000000];
      let response = [];
      for (let i = 0; i < 7; i++) {
        let amount = amounts[Math.floor(Math.random() * 6) + 1];
        response.push({
          id: i + 1,
          airlineName: airlines[Math.floor(Math.random() * 6) + 1],
          amount: amount,
          numberOfTokens: amount / 1000
        });
      }
      resolve(appHelpers.promiseResponse(response));
    }, 2000);
  });
}

function getAirlinesThreshold(airportCode, from, size) {
  airportCode = airportCode === "-1" ? "" : airportCode;

  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/GetAllAirlineWalletThreshold?AirlineId=&AirportCode=${airportCode}&From=${from}&Size=${size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//
// function getAirlinesThreshold(from, size) {
//     //     return appHelpers.getRequest(`http://psc-api.test.vggdev.com/api/AirlineWalletThreshold/GetAllPendingAirlineWalletThreshold?From=${from}&Size=${size}`, authHeader())
//     return appHelpers.getRequest(`http://psc-api.test.vggdev.com/api/AirlineWalletThreshold/GetAllAirlineWalletThreshold`, authHeader()
//         .then(res => {
//             return res;
//         }).catch(
//             error => {
//                 let errorMessage = appHelpers.interpretErrorResponse(error);
//                 return appHelpers.formatPromiseResponse(errorMessage, appConstants.ERROR_RESPONSE);
//             }
//         );
// }

function getAllThreshold(airlineId, airportCode, status, from, size) {
  airportCode = airportCode === "-1" ? "" : airportCode;
  airlineId = airlineId === "-1" ? "" : airlineId;
  status = status === "-1" ? "" : status;
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/GetAllPendingAirlineWalletThreshold?AirlineId=${airlineId}&AirportCode=${airportCode}&Status=${status}&From=${from}&Size=${size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
//
// function searchThreshold(airlineId,from,size) {
//     return appHelpers.getRequest(`http://psc-api.test.vggdev.com/api/AirlineWalletThreshold/GetAllUnprocessedAirlineWalletThreshold?AirlineId=${airlineId}&From=${from}&Size=${size}`, authHeader())
//         .then(res => {
//             return res;
//         }).catch(
//             error => {
//                 let errorMessage = appHelpers.interpretErrorResponse(error);
//                 return appHelpers.formatPromiseResponse(errorMessage, appConstants.ERROR_RESPONSE);
//             }
//         );
// }

function editPendingThreshold(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/EditPendingAirlineWalletThreshold`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approvePendingThreshold(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/Approve`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function setThreshold(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/SaveAirlineWalletThreshold`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getCurrentPsc() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/PscCharges/Get`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllPsc(from, size) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/PscCharges/GetAll?From=${from}&Size=${size}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllUnprocessedPendingPsc(from, size) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/PscCharges/GetUnprocessedPendingPscCharges?From=${from}&Size=${size}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function savePsc(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscCharges/Save`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function editPsc(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscCharges/EditPendingPscCharge`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approvePsc(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscCharges/Approve`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getNotificationType() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Notification/NotificationType`)
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getNotificationEmail(from, size) {
  return (
    appHelpers
      .getRequest(
        `${appConstants.PAS_URL}/api/Notification/GetAllNotificationEmail?From=${from}&Size=${size}`
      )
      //return appHelpers.getRequest(`${appConstants.PAS_URL}/api/Notification/GetNotificationEmails?AirlineId=${airlineId}&AirportCode=${airportCode}&From=${from}&Size=${size}`)
      .then(data => {
        return data;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function editNotification(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Notification/SaveNotification`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchNotificationEmail(airlineId, airportCode, from, size) {
  airportCode = airportCode === "-1" ? "" : airportCode;
  airlineId = airlineId === "-1" ? "" : airlineId;
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Notification/GetNotificationEmails?AirlineId=${airlineId}&AirportCode=${airportCode}&From=${from}&Size=${size}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function addEmailNotification(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Notification/SaveNotification`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchDashboardSummaryCard(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchDashboardSummary`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function fetchTokenUtilizationByAirline(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenUtilizationByAirline`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTokenActivity(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenActivityPerMonth`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchTokenUtilizationByAirport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenUtilizationByAirport`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchLatestTokensPurchase(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchLatestTokenPurchases`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function searchTokenUtilized(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/SearchTokenUtilizedByAirlineAndAirport`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTransitPassenger(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/TransitPassenger/SearchTransitPassengers`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadTransitPassenger(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/TransitPassenger/DownloadTransitPassengers`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchBillableVsTotalPassengers(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/GetTotalVersusBillable`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function downloadTokenUtilization(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadTokenUtilizedByAirlineAndAirport`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function downloadBillableVsTotalPassengers(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadTotalVersusBillable`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getSettlements(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Settlement/GetSettlement`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadSettlements(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Settlement/DownloadSettlement`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getOtherReconciliation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/Search`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getMyReconciliation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/SearchMyReconciliation`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function processReconciliation(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/Process`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function updateReconciliation(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscReconciliation/Edit`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function addReconciliation(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscReconciliation/Add`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAuditModules() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/AuditTrail/GetAllModuleActions`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getAuditActions() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/AuditTrail/GetAllAuditActions`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchAudits(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/AuditTrail/Search`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTimeline(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/Report/SearchTxnLog`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getWalletMovementData(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/dashboard/SearchCurrentTokenMovement`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveDataEntry(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCSaveDataEntry`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getDataEntry(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCSearchManifestPending `,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function processDataEntry(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCProcessManifestPending`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchPendingAirlineRoute(payload) {
  // return appHelpers.postRequest(`${appConstants.PAS_URL}/api/Manifest/PSCProcessManifestPending`, payload)
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/SearchPendingAirlineRoute`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function saveAirlineRoute(payload) {
  // return appHelpers.postRequest(`${appConstants.PAS_URL}/api/Manifest/PSCProcessManifestPending`, payload)
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/AirlineRoute/Save`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function airlineRouteApproval(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/ApprovePendingAirlineRoute`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function searchAirlineRoute(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/SearchAirlineRoute?AirlineId=${payload.AirlineId}&From=${payload.From}&Size=${payload.Size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchAirlineWalletReport(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Settlement/GetAirlineWallet`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadAirlineWalletReport(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Settlement/DownloadAirlineWallet`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function savePdm(payload) {
  return (
    appHelpers
      .postRequest(`${appConstants.PAS_URL}/api/Manifest/SavePdm`, payload)
      // return appHelpers.postRequest(`http://psc-api.test.vggdev.com/api/Manifest/SavePdm`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function searchPdm(payload) {
  return (
    appHelpers
      .postRequest(`${appConstants.PAS_URL}/api/Manifest/SearchPdm`, payload)
      // return appHelpers.postRequest(`http://psc-api.test.vggdev.com/api/Manifest/SearchPdm`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function getBillablePassengers() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/BillablePassenger/GetBillablePassenger`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveBillablePassengers(payload) {
  return (
    appHelpers
      .postRequest(
        `${appConstants.PAS_URL}/api/BillablePassenger/AddBillablePassenger`,
        payload
      )
      // return appHelpers.postRequest(`http://psc-api.test.vggdev.com/api/BillablePassenger/AddBillablePassenger`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function searchAppEntityTypes(AppId) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/RoleEntity/Application?appId=${AppId}`,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function createMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/CreateMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/SearchMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approveMakerChecker(payload) {
  const { user } = store.getState();
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/ApproveMakerChecker`,
      payload,
      { ApprovedBy: user.userId }
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function rejectMakerChecker(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/MakerChecker/RejectMakerChecker`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getStatementOfAccount(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/GetStatementOfAccount`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadStatementOfAccount(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadStatementOfAccount`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadPdm(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPdm`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//REGIONAL END POINTS

//Regional PDM
function downloadSettlementsRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Settlement/DownloadSettlementPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function savePdmRegional(payload) {
  return (
    appHelpers
      .postRequest(`${appConstants.PAS_URL}/api/Manifest/SavePdmPSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function searchPdmRegional(payload) {
  return (
    appHelpers.postRequest(`${appConstants.PAS_URL}/api/Manifest/SearchPdmPSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}


function downloadPdmRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPdmPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
//Airline Payment, Passenger Data
function searchAirlinePaymentRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Payment/SearchPSCPaymentsPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadAirlinePaymentRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Payment/DownloadPSCPaymentsPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getFlightsRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/SearchPSCManifestsPSCR?from=${payload.From}&size=${payload.Size}`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAirlinesFlightNumbersRegional(airlineId) {
  let payload = {
    From: 0,
    PageSize: 2000,
    Parameter: { AirlineId: airlineId }
  };
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Flight/search`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadFlightsRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPSCManifestsPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getFlightPassengersRegional(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Manifest/GetPSCPassengersPSCR?manifestId=${payload.manifestId}&from=${payload.From}&size=${payload.Size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadFlightPassengersRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Manifest/DownloadPSCPassengersPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// Audit Trail
function getAuditModulesRegional() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/AuditTrail/GetAllModuleActionsPSCR`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAuditActionsRegional() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/AuditTrail/GetAllAuditActionsPSCR`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchAuditsRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/AuditTrail/SearchPSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// Billable Passenger
function downloadBillableVsTotalPassengersRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadTotalVersusBillablePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchBillableVsTotalPassengersRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/GetTotalVersusBillablePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getBillablePassengersRegional() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/BillablePassenger/GetBillablePassengerPSCR`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// Email Settings
function getNotificationTypeRegional() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Notification/NotificationTypePSCR`)
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function editNotificationRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Notification/SaveNotificationPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchNotificationEmailRegional(airlineId, airportCode, from, size) {
  airportCode = airportCode === "-1" ? "" : airportCode;
  airlineId = airlineId === "-1" ? "" : airlineId;
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Notification/GetNotificationEmailsPSCR?AirlineId=${airlineId}&AirportCode=${airportCode}&From=${from}&Size=${size}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function addEmailNotificationRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Notification/SaveNotificationPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//PSC Settlement
function getSettlementsRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Settlement/GetSettlementPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Outstanding Settlement
function getOutstandingBillablePassengerReportRegional(payload) {
  return appHelpers
  .postRequest(`${appConstants.PAS_URL}/api/Report/SearchOutstandingBillablePassengerReportPSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadOutstandingBillablePassengerReportRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/report/DownloadOutstandingBillablePassengerReportPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}


//Settings
function getAirlinesThresholdRegional(airportCode, from, size) {
  airportCode = airportCode === "-1" ? "" : airportCode;

  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/GetAllAirlineWalletThresholdPSCR?AirlineId=&AirportCode=${airportCode}&From=${from}&Size=${size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllThresholdRegional(airlineId, airportCode, status, from, size, currency) {

  return appHelpers
      .getRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/GetAllPendingAirlineWalletThresholdPSCR?AirlineId=${airlineId}&AirportCode=${airportCode}&Currency=${currency}&Status=${status}&From=${from}&Size=${size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getCurrentPscRegional(payload) {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/PscCharges/GetPSCR?ServiceType=${payload.serviceType}`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function setThresholdRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/SaveAirlineWalletThresholdPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function editPendingThresholdRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/EditPendingAirlineWalletThresholdPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approvePendingThresholdRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineWalletThreshold/ApprovePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
function getAllPscRegional(from, size) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/PscCharges/GetAllPSCR?From=${from}&Size=${size}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Exchange rate
function searchExchangeRateRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/SearchExchangeRatePSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchExchangeRatePendingRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/SearchExchangeRatePendingPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveExchangeRatePendingRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/SaveExchangeRatePendingPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approveExchangeRatePendingRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/ApproveExchangeRatePendingPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function rejectExchangeRatePendingRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/RejectExchangeRatePendingPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchPulledInvoiceRegional(payload) {
  return (
    // appHelpers.postRequest(`http://pscregional-api.test.vggdev.com/api/PulledInvoice/SearchPulledInvoice`, payload)
    appHelpers.postRequest(`${appConstants.PAS_URL}/api/PulledInvoice/SearchPulledInvoicePSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function approvePulledInvoice(payload) {
  return (
    appHelpers.postRequest(`${appConstants.PAS_URL}/api/PulledInvoice/ApprovePulledInvoicePSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function initiatePulledInvoice(payload) {
  return (
    // appHelpers.postRequest(`http://pscregional-api.test.vggdev.com/api/PulledInvoice/IniatePendingInvoice`, payload)
    appHelpers.postRequest(`${appConstants.PAS_URL}/api/PulledInvoice/IniatePendingInvoicePSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

function rejectPulledInvoice(payload) {
  return (
    appHelpers.postRequest(`${appConstants.PAS_URL}/api/PulledInvoice/RejectPullInvoicePSCR`, payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      })
  );
}

//Dashboard

function fetchDashboardSummaryCardRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchDashboardSummaryPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchTokenUtilizationByAirlineRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenUtilizationByAirlinePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTokenActivityRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenActivityPerMonthPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchTokenUtilizationByAirportRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchTokenUtilizationByAirportPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchLatestTokensPurchaseRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Dashboard/SearchLatestTokenPurchasesPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Airline Routes

function searchPendingAirlineRouteRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/SearchPendingAirlineRoutePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function airlineRouteApprovalRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/ApprovePendingAirlineRoutePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveAirlineRouteRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/AirlineRoute/SavePSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllAirlinesRegional() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/airline/getallpscairlinePSCR`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllAirportsRegional() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Airport/GetAllPscAirportPSCR`)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchAirlineRouteRegional(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/AirlineRoute/SearchAirlineRoutePSCR?AirlineId=${payload.AirlineId}&isRegional=${payload.IsRegional}&From=${payload.From}&Size=${payload.Size}`
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Reconcilaiation

function processReconciliationRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/ProcessPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getOtherReconciliationRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/SearchPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getMyReconciliationRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscReconciliation/SearchMyReconciliationPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function updateReconciliationRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscReconciliation/EditPSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function addReconciliationRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscReconciliation/AddPSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Data Entry

function processDataEntryRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCProcessManifestPendingPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getDataEntryRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCSearchManifestPendingPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function saveDataEntryRegional(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/Manifest/PSCSaveDataEntryPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//psc utilization
function downloadTokenUtilizationRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadTokenUtilizedByAirlineAndAirportPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTokenUtilizedRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/SearchTokenUtilizedByAirlineAndAirportPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//transit passenger

function downloadTransitPassengerRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/TransitPassenger/DownloadTransitPassengersPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTransitPassengerRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/TransitPassenger/SearchTransitPassengersPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Statement of Account
function getStatementOfAccountRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Report/GetStatementOfAccountPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadStatementOfAccountRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Report/DownloadStatementOfAccountPSCR`,
      payload,
      authHeader()
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Airline Wallet

function searchAirlineWalletReportRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Settlement/GetAirlineWalletPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadAirlineWalletReportRegional(payload) {
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/Settlement/DownloadAirlineWalletPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

//Psc setting
function getAllUnprocessedPendingPscRegional(from, size,serviceType) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/PscCharges/GetUnprocessedPendingPscChargesPSCR?From=${from}&Size=${size}&ServiceType=${serviceType}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function savePscRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscCharges/SavePSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function editPscRegional(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/PscCharges/EditPendingPscChargePSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function approvePscRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/PscCharges/ApprovePSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchTimelineRegional(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/Report/SearchTxnLogPSCR`, payload)
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllCurrencies() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Common/CurrenciesPSCR`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getAllServiceTypes() {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Common/ServiceTypesPSCR`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}


// Download Data Entry
function downloadDataEntryRegional(payload) {
  return appHelpers
    .postRequest(
       `${appConstants.PAS_URL}/api/Manifest/DownloadManifestPendingPSCR`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function searchFaq(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.FAQ_URL}/api/Faq/GetProductFaqs`,
      payload
    )
    .then(res => {
      return res;
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}



// WEBPACK FOOTER //
// ./src/_services/common.service.js